import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { I18nService } from './core/services/i18n.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <div class="app-root" [attr.dir]="i18n.direction()" [attr.lang]="i18n.currentLanguage()">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    .app-root {
      min-height: 100vh;
    }
  `]
})
export class AppComponent {
  readonly i18n = inject(I18nService);
}
